import React from "react";
import Router from "./routes";
import "./Styles/globals.css";
import { Toaster } from "react-hot-toast";
import LottieAnimation from "./Animations/LottieAnimation";
import ErrorBoundary from "./errorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <div className="App">
        <LottieAnimation />
        <Toaster
          position="top-center"
          reverseOrder={false}
          toastOptions={{
            style: { zIndex: 99999 },
          }}
          containerStyle={{ zIndex: 99999 }}
        />
        <Router />
      </div>
    </ErrorBoundary>
  );
}

export default App;